import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

import {
  // JoinUs,
  OurDoctors,
  OurServices,
  Testimonial,
  Blog,
} from "components";

import {
  WaveLightInfoSection,
  HowWaveLightWorks,
  StepsSection,
  VisionHeroSection,
  FaqSection,
  Banner,
} from "./components";



const WaveLightPlus = () => {
  return (
    <Box>
      <Helmet>
        <title></title>

        <meta
          name="description"
          content="Get bladeless LASIK surgery in Chennai with AI-guided WaveLight Plus technology. Advanced laser eye surgery for eye power correction — 98% achieve 20/20 vision. Book your free consultation at Amrit Hospitals today."
        />

        <meta
          name="keywords"
          content="bladeless LASIK surgery"
        />

        <meta
          name="title"
          content="Bladeless LASIK Surgery in Chennai | WaveLight Plus – Amrit Hospitals"
        />
      </Helmet>

      <Banner />
      <WaveLightInfoSection />
      <HowWaveLightWorks />
      <StepsSection />
      <VisionHeroSection />

      {/* FAQ Section */}
   <FaqSection />
    </Box>
  );
};

export default WaveLightPlus;